import { showErrorMessage } from '../dialogs';

const self = {
    getErrorFromValidatorWithoutDirtyCheck(validator) {
        if (!validator || !validator.$invalid) {
            return false;
        }
        return self.getError(validator);
    },
    getErrorFromValidator(validator) {
        if (!validator || !validator.$invalid || !validator.$dirty) {
            return false;
        }
        return self.getError(validator);
    },
    getError(validator) {
        if (validator.required === false) {
            return 'verplicht';
        }

        if (validator.numeric === false) {
            return 'moet numeriek zijn';
        }

        if (validator.integer === false) {
            return 'moet integer zijn';
        }

        if (validator.minValue === false) {
            return 'min. ' + validator.$params.minValue.min;
        }

        if (validator.validDate === false) {
            return 'validDate error';
        }

        if (validator.validTime === false) {
            return 'validTime error';
        }

        if (validator.isAfter === false) {
            return 'isAfter error';
        }

        if (validator.isAfterOrSame === false) {
            return 'isAfterOrSame error';
        }

        if (validator.validAreaCalculationFormula === false) {
            return 'product_types.area_calculation_formula.validation.invalid_format';
        }

        if (validator.validPaintAreaCalculationFormula === false) {
            return 'product_types.paint_area_calculation_formula.validation.invalid_format';
        }

        if (validator.validDecimalPrecision === false) {
            return 'general.validation.decimal_precision';
        }

        if (validator.validHtml === false) {
            return 'general.validation.valid_html';
        }

        return false;
    },
    parseError(responseText) {
        let result = responseText;

        // Only parse if it is a string
        if (typeof result === 'string' || result instanceof String) {
            try {
                result = JSON.parse(responseText);
            } catch (e) {}
        }

        if (result == null) {
            return responseText;
        }

        if (typeof result === 'string' || result instanceof String) {
            return result;
        }

        if (result.hasOwnProperty('data')) {
            return String(result['data']);
        }

        // Get first property if 'data' doesn't exist
        for (var prop in result) {
            return String(result[prop]);
        }

        return String(result);
    },

    displayError(error, translations, callback) {
        if (error.response && error.response.data) {
            const errorResponse = error.response.data;
            if (errorResponse) {
                if ('code' in errorResponse && errorResponse != null) {
                    if (errorResponse.code in translations) {
                        return showErrorMessage(
                            translations[errorResponse.code],
                            callback
                        );
                    }
                }
            }
        }
        return showErrorMessage('Er trad een onbekende fout op.');
    },
};
export default self;

export function getDefaultTranslationKey(statusCode) {
    switch (statusCode) {
        // Client Error Responses (4xx)
        case 400:
            return 'default_errors.bad_request';
        case 402:
            return 'default_errors.payment_required';
        case 403:
            return 'default_errors.forbidden';
        case 404:
            return 'default_errors.not_found';
        case 405:
            return 'default_errors.method_not_allowed';
        case 406:
            return 'default_errors.not_acceptable';
        case 407:
            return 'default_errors.proxy_authentication_required';
        case 408:
            return 'default_errors.request_timeout';
        case 409:
            return 'default_errors.conflict';
        case 410:
            return 'default_errors.gone';
        case 411:
            return 'default_errors.length_required';
        case 412:
            return 'default_errors.precondition_failed';
        case 413:
            return 'default_errors.payload_too_large';
        case 414:
            return 'default_errors.uri_too_long';
        case 415:
            return 'default_errors.unsupported_media_type';
        case 416:
            return 'default_errors.range_not_satisfiable';
        case 417:
            return 'default_errors.expectation_failed';
        case 418:
            return 'default_errors.im_a_teapot';
        case 421:
            return 'default_errors.misdirected_request';
        case 422:
            return 'default_errors.unprocessable_entity';
        case 423:
            return 'default_errors.locked';
        case 424:
            return 'default_errors.failed_dependency';
        case 425:
            return 'default_errors.too_early';
        case 426:
            return 'default_errors.upgrade_required';
        case 428:
            return 'default_errors.precondition_required';
        case 429:
            return 'default_errors.too_many_requests';
        case 431:
            return 'default_errors.request_header_fields_too_large';
        case 451:
            return 'default_errors.unavailable_for_legal_reasons';

        // Server Error Responses (5xx)
        case 500:
            return 'default_errors.server';
        case 502:
            return 'default_errors.bad_gateway';
        case 503:
            return 'default_errors.service_unavailable';
        case 504:
            return 'default_errors.gateway_timeout';
        case 505:
            return 'default_errors.http_version_not_supported';
        case 506:
            return 'default_errors.variant_also_negotiates';
        case 507:
            return 'default_errors.insufficient_storage';
        case 508:
            return 'default_errors.loop_detected';
        case 510:
            return 'default_errors.not_extended';
        case 511:
            return 'default_errors.network_authentication_required';

        default:
            return 'default_errors.unknown';
    }
}
